import { render, staticRenderFns } from "./InfoFooter.vue?vue&type=template&id=77f71b3e&scoped=true"
import script from "./InfoFooter.vue?vue&type=script&lang=js"
export * from "./InfoFooter.vue?vue&type=script&lang=js"
import style0 from "./InfoFooter.vue?vue&type=style&index=0&id=77f71b3e&prod&lang=scss&scoped=true"
import style1 from "./InfoFooter.vue?vue&type=style&index=1&id=77f71b3e&prod&scss=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f71b3e",
  null
  
)

export default component.exports